import React, { useState } from 'react';
import './address.scss';
import Icon from '../Icon/Icon';
import Button from '../../common/Button/Button';
import { initializeMap } from 'hb-redux-store/util/locationService';
import history from 'hb-redux-store/history';
import { Link } from 'react-router-dom';
import { checkoutPrefix } from '../../../feature/checkout/checkout.routes';
import { ACCOUNTS_PREFIX } from '../../../feature/account/accounts.routes';
import { subscriptionPrefix } from '../Subscription/subscription.routes';

const AddressCard = props => {
  // const [ confirmEdit, setConfirmEdit ] = useState(false);
  const {
    address,
    onSelectedAddressChange,
    selectedAddressId,
    onDelete,
    onSetDefaultAddress,
  } = props;
  const { addressId, default: isDefaultAddress } = address;

  const { source, goToShipment } = props;
  const isCheckout = source === 'checkout';
  const isAccounts = source === 'accounts';
  const isSubscription = source === subscriptionPrefix;
  let prefix = ACCOUNTS_PREFIX;
  const subscriptionAddress = isSubscription;
  if (isCheckout) prefix = checkoutPrefix;
  if (isSubscription) prefix = subscriptionPrefix;

  const editLink = `/${prefix}/new-address/${addressId}?edit=true`;
  const onEdit = address => {
    const defaultGeoLocation = {
      coords: {
        latitude: address.latitude,
        longitude: address.longitude,
      },
    };
    initializeMap(defaultGeoLocation);
    setTimeout(() => {
      history.push(editLink);
    }, 50);
  };
  return (
    <div className="address-card">
      <div
        className="justify-content--space-between"
        onClick={() =>
          onSelectedAddressChange(addressId, {
            ...address,
            subscriptionAddress,
          })
        }
      >
        <div className="address-card--name">{address.fullName}</div>
        {(isCheckout || isSubscription) && (
          <Icon
            size={17}
            class={
              addressId === selectedAddressId
                ? 'icon-common-radio-selected'
                : 'icon-common-radio-unselected'
            }
          />
        )}
      </div>
      <div className="address-card--address-lines">
        {address.addressLine1} <br />
        {address.addressLine2 || address.area} <br />
        {address.city}, {address.pinCode} <br />
        {address.mobile}
      </div>
      {(isCheckout || isSubscription) && addressId === selectedAddressId && (
        <div className="justify-content--space-between">
          <Button
            onClick={onEdit}
            className="button action-link address-card--edit-action"
          >
            Edit
          </Button>
          <Button
            className="button button-primary"
            onClick={() => {
              goToShipment({ ...address, subscriptionAddress });
            }}
          >
            deliver to this address
          </Button>
        </div>
      )}
      {isAccounts && (
        <React.Fragment>
          <div
            className="justify-content--space-between address-card--default-address"
            onClick={() => onSetDefaultAddress(addressId)}
          >
            <div>Make this default address</div>
            {isDefaultAddress ? (
              <Icon size={20} class="icon-common-radio-selected" />
            ) : (
              <Icon size={20} class="icon-common-radio-unselected" />
            )}
          </div>
          <div className="justify-content--space-between">
            <Button
              onClick={() => onDelete(addressId)}
              className="button action-link address-card--delete-action"
            >
              Delete
            </Button>
            <Link
              onClick={onEdit}
              className="button action-link address-card--edit-action"
            >
              Edit
            </Link>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default AddressCard;
